import React from "react";
import {
  Redirect as ReactRouterRedirect,
  RedirectProps
} from "react-router-dom";

import useRouter from "@/utils/useRouter";
import useModalRoutes from "./useModalRoutes";

import { matchRoutes } from "react-router-config";

type Location = import("history").Location;

const Redirect: React.FC<RedirectProps> = props => {
  const { history, location } = useRouter();
  const background = location.state?.background;
  const modalRoutes = useModalRoutes();
  const isModalRoute = matchRoutes(modalRoutes, history.location.pathname);

  if (props.to === background) {
    return null;
  }

  if (!background && isModalRoute.length > 0) {
    history.replace({
      ...history.location,
      state: {
        background: {
          pathname: props.to,
          state: null,
          hash: "",
          search: ""
        } as Location
      }
    });
    return null;
  }

  return <ReactRouterRedirect {...props} />;
};

export default Redirect;
